import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t-2 py-6">
      <div className="container mx-auto flex flex-col items-center sm:flex-row justify-center gap-6">
        <span className="font12 font-inter text-sm mr-2">
          ©2025-{currentYear} Bizwit Insights · All rights reserved with Bizwit Research
          & Consulting LLP.
        </span>
        <div className="flex lg:space-x-6 space-x-4 font13 font-medium font-dmSans text-sm">
          <Link to="/Term-of-Use" className="hover:text-gray-800">
            Term of use
          </Link>
          <Link to="/Privacy-Policy" className="hover:text-gray-800">
            Privacy policy
          </Link>
          <Link to="/help&faq" className="hover:text-gray-800">
            Help & FAQ
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
